/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiColorConfig} from "./UiColorConfig";
import {UiCalendarDataConfig} from "./UiCalendarDataConfig";
import {UiCalendarViewMode} from "./UiCalendarViewMode";
import {UiWeekDay} from "./UiWeekDay";


export interface UiCalendarConfig extends UiComponentConfig {
	_type?: string;
	eventContentTemplates: {[name: string]: UiTemplateConfig};
	viewModes?: UiCalendarViewMode[];
	activeViewMode?: UiCalendarViewMode;
	displayedDate?: number;
	showHeader?: boolean;
	tableBorder?: boolean;
	showWeekNumbers?: boolean;
	businessHoursStart?: number;
	businessHoursEnd?: number;
	firstDayOfWeek?: UiWeekDay;
	workingDays?: UiWeekDay[];
	tableHeaderBackgroundColor?: UiColorConfig;
	idPropertyName?: string;
	startPropertyName?: string;
	endPropertyName?: string;
	templatePropertyName?: string;
	allDayPropertyName?: string;
	allowDragOperationsPropertyName?: string;
	backgroundColorPropertyName?: string;
	borderColorPropertyName?: string;
	renderingPropertyName?: string;
	defaultBackgroundColor?: UiColorConfig;
	defaultBorderColor?: UiColorConfig;
	initialData?: UiCalendarDataConfig
}

export interface UiCalendarCommandHandler {
	setViewMode(viewMode: UiCalendarViewMode): void;
	setDisplayedDate(date: number): void;
	addEvent(theEvent: any): void;
	removeEvent(eventId: any): void;
	setCalendarData(data: UiCalendarDataConfig, clearCalendar: boolean): void;
	clearCalendar(): void;
}

export interface UiCalendarEventSource {
	onEventClicked: TeamAppsEvent<UiCalendar_EventClickedEvent>;
	onEventMoved: TeamAppsEvent<UiCalendar_EventMovedEvent>;
	onDayClicked: TeamAppsEvent<UiCalendar_DayClickedEvent>;
	onViewChanged: TeamAppsEvent<UiCalendar_ViewChangedEvent>;
	onDataNeeded: TeamAppsEvent<UiCalendar_DataNeededEvent>;
}

export interface UiCalendar_EventClickedEvent extends UiEvent {
	_type: "UiCalendar.eventClicked";
	redundancyKey?: string;
	eventId: any;
	isDoubleClick: boolean
}

export interface UiCalendar_EventMovedEvent extends UiEvent {
	_type: "UiCalendar.eventMoved";
	redundancyKey?: string;
	eventId: any;
	newStart: number;
	newEnd: number
}

export interface UiCalendar_DayClickedEvent extends UiEvent {
	_type: "UiCalendar.dayClicked";
	redundancyKey?: string;
	date: number;
	isDoubleClick: boolean
}

export interface UiCalendar_ViewChangedEvent extends UiEvent {
	_type: "UiCalendar.viewChanged";
	redundancyKey?: string;
	viewMode: UiCalendarViewMode;
	mainIntervalStart: number;
	mainIntervalEnd: number;
	displayedIntervalStart: number;
	displayedIntervalEnd: number
}

export interface UiCalendar_DataNeededEvent extends UiEvent {
	_type: "UiCalendar.dataNeeded";
	redundancyKey?: string;
	requestIntervalStart: number;
	requestIntervalEnd: number
}

